import React, { useState } from "react";

import { SystemIcon } from "@justworkshr/milo-components";

import styles from "./Stepper.module.css";

interface IStepsProps {
  label: string;
}

interface IStepperProps {
  currentStep: number;
  steps: Array<IStepsProps>;
  onClick: (stepNumber: number) => void;
  status: number;
  disabled?: boolean;
}

const Stepper = ({ ...props }: IStepperProps): JSX.Element => {
  const { steps, currentStep, onClick, status, disabled } = props;

  const [showStepper, setShowStepper] = useState<boolean>(false);

  const currentStepData = steps?.find((_, index) => index + 1 === currentStep);

  return (
    <div className={styles.stepperContainer}>
      <button
        className={styles.mobileHeader}
        onClick={() => setShowStepper(!showStepper)}
      >
        <div className={styles.headerLabel}>
          {currentStep < status ? (
            <div className={`${styles.stepIcon} ${styles.pastStepIcon}`}>
              <SystemIcon
                iconName="check"
                color="inverse"
                title="person"
                size="extra-small"
              />
            </div>
          ) : (
            <div className={`${styles.stepIcon} ${styles.currentStepIcon}`}>
              {currentStep}
            </div>
          )}

          <span>{currentStepData?.label}</span>
        </div>

        <SystemIcon
          className={`${styles.caret} ${showStepper ? styles.caretUp : ""}`}
          iconName="caret"
          title="person"
          size="medium"
        />
      </button>
      <div
        className={`${styles.stepper} ${
          !showStepper ? styles.stepperHiding : styles.stepperShowing
        }`}
      >
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCurrentStep = currentStep === stepNumber;
          const isPreviousStep = stepNumber < status;

          const buttonClassName = isCurrentStep
            ? styles.currentStep
            : isPreviousStep
            ? styles.previousStep
            : styles.nextStep;

          const handleOnClick = () => {
            if (stepNumber > status) {
              return;
            }
            onClick(stepNumber);
            setShowStepper(false);
          };
          return (
            <button
              key={index}
              onClick={handleOnClick}
              className={buttonClassName}
              disabled={disabled}
            >
              {isPreviousStep ? (
                <div className={`${styles.stepIcon} ${styles.pastStepIcon}`}>
                  <SystemIcon
                    iconName="check"
                    color="inverse"
                    title="person"
                    size="extra-small"
                  />
                </div>
              ) : isCurrentStep ? (
                <div className={`${styles.stepIcon} ${styles.currentStepIcon}`}>
                  {stepNumber}
                </div>
              ) : (
                <div className={`${styles.stepIcon}`}>{stepNumber}</div>
              )}

              <span>{step.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
